import React from "react";
import { Mui } from "@osu/react-ui";
import { useSelector, useDispatch } from "react-redux";
import { hasNoSiblingsSelected, toggleCheck, selector } from "../slices/administrativeNotes";

const RenderInputControls = (props) => {
    const {
        section,
        requirementInstructionsEle,
        allPossibleNotes = {},
        readonly,
    } = props;

    const noteState = useSelector(selector), noteDispatch = useDispatch();
    const notes = allPossibleNotes[section] ?? []; // Default prevents page from erroring out
    
    const renderInputControls = () => {
        let fields = [];
        let parentLabelExistsAndIsChecked = false;        
        
        function toggleNote(event) {
            if (readonly) { return; }
            const { checked, name: label, type, value } = event.target;
            const actionPayload = { checked, label, type, value, section };
            noteDispatch(toggleCheck(actionPayload));
        }

        for (let note of notes) {
            const parentLabelExists = note.parentLabel ? true : false;
            const parentLabelExistsAndIsNotChecked = parentLabelExists && !noteState.find(item => item.label === note.parentLabel)?.value ? true : false;
            parentLabelExistsAndIsChecked = parentLabelExists && !parentLabelExistsAndIsNotChecked;

            const isChecked = !!(noteState.find(item => item.label === note.label && item.section === section)?.value);
            const isDisabled = readonly || parentLabelExistsAndIsNotChecked;
            const color = hasNoSiblingsSelected(note, noteState, section) && "red";
            const asteriskAfterLabel = parentLabelExistsAndIsChecked ? "\u00A0*" : "";

            fields.push(
                <Mui.FormControlLabel
                    control={
                        <Mui.Checkbox
                            checked={isChecked}
                            onChange={toggleNote}
                            color="primary"
                            name={note.label}
                            disabled={isDisabled}
                            style={{ paddingLeft: note.parentLabel && '2rem', color }}
                        />
                    }
                    key={note.label}
                    label={`${note.label}${asteriskAfterLabel}`}
                />
            );
        }

        if (requirementInstructionsEle?.[0] && parentLabelExistsAndIsChecked) {
            fields.push(requirementInstructionsEle[0]); // Show instructions at the end
        } else if (requirementInstructionsEle?.[1]) {
            const invisibleEle = requirementInstructionsEle[1];
            fields.push(invisibleEle); // Reserve space to prevent elements from jumping around
        }
        return fields;
    }

    return (
        <Mui.FormGroup>
            {renderInputControls()}
        </Mui.FormGroup>
    );
};
export default RenderInputControls;